import { BASE_URL } from '@/constants/config.js'

export const canOpenMedia = path => {
  const extension = new URL(path, BASE_URL).pathname.split('.').pop().toLowerCase()
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'bmp', 'ico', 'svg', 'pdf', 'txt'].includes(extension)) return true
  const videoTypes = { mp4: 'video/mp4', webm: 'video/webm', ogv: 'video/ogg', mov: 'video/quicktime', m4v: 'video/mp4' }
  const audioTypes = { mp3: 'audio/mpeg', wav: 'audio/wav', ogg: 'audio/ogg', m4a: 'audio/mp4', aac: 'audio/aac', flac: 'audio/flac' }
  if (videoTypes[extension]) return !!document.createElement('video').canPlayType(videoTypes[extension])
  if (audioTypes[extension]) return !!document.createElement('audio').canPlayType(audioTypes[extension])
  return false
}
export const mediaUrl = path => {
  if (canOpenMedia(path)) return new URL(path, BASE_URL).href
  const name = new URL(path, BASE_URL).pathname.split('/').pop()
  return BASE_URL + 'download-tender.php?file=' + encodeURIComponent(decodeURIComponent(name))
}

export const mediaUploadLimitMessage = bytes => bytes > 0
  ? 'The maximum media upload size is ' + Number((bytes / (1024 * 1024)).toFixed(2)) + ' MB. Please try again with a smaller file.'
  : 'This file exceeds the maximum media upload size. Please try again with a smaller file.'
